export type ActivationStepKey =
  | 'first_blog' | 'mailinglist' | 'first_newsletter' | 'social_connected' | 'first_post';

export interface ActivationStepDef {
  key: ActivationStepKey;
  title: string;
  body: string;
  ctaRoute: string;
  ctaLabel: string;
}

// Vaste volgorde: e-mail (rode draad, hero = nieuwsbrief) vóór social.
export const ACTIVATION_STEPS: ActivationStepDef[] = [
  { key: 'first_blog', title: 'Publiceer je eerste blog', body: 'Schrijf en publiceer je eerste blog. Dat is je startpunt.', ctaRoute: '/dashboard/new-blog', ctaLabel: 'Schrijf je eerste blog' },
  { key: 'mailinglist', title: 'Vul je mailinglijst', body: 'Voeg een paar mensen toe naar wie je je blog wilt sturen.', ctaRoute: '/mailinglist', ctaLabel: 'Voeg mensen toe' },
  { key: 'first_newsletter', title: 'Stuur je eerste nieuwsbrief', body: 'Stuur je blog als nieuwsbrief naar je achterban. Dit is de belangrijkste stap.', ctaRoute: '/campaigns/create/from-blog', ctaLabel: 'Maak je eerste nieuwsbrief' },
  { key: 'social_connected', title: 'Koppel je social media', body: 'Koppel je accounts zodat je vanuit dibbi kunt posten.', ctaRoute: '/dashboard/settings?tab=socials', ctaLabel: 'Koppel je accounts' },
  { key: 'first_post', title: 'Plaats je eerste social post', body: 'Deel je blog ook op social media.', ctaRoute: '/social-media/create', ctaLabel: 'Maak je eerste post' },
];
